export default {
  data () {
    return {
      comparisonData: []
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/ComparisonData.js